export default "__VITE_ASSET__f67ec0f3__"